import ApiService from './apiService'

export default function useApi(axiosIns, jwtOverrideConfig) {
  const api = new ApiService(axiosIns, jwtOverrideConfig)

  return {
    api,
  }
}
